import preloader from '@/components/preloader'
import textOverflow from '@/components/text/overflow'

const className = 'tag'

function renderCancelable(h) {
  if (this.cancelable) {
    return h(
      'div',
      {
        class: `${className}__cancel`,
        on: {
          click: event => {
            event.preventDefault()
            event.stopPropagation()
            if (typeof this.cancel === 'function') {
              this.cancel()
            }
          }
        }
      }
    )
  }
}
function renderDefaultSlot() {
  if (this.$scopedSlots.default) {
    return this.$scopedSlots.default()
  }

  return this.$slots.default
}
function renderLabelContent(h) {
  if (this.$_label) {
    return h(
      textOverflow,
      {
        props: {
          value: this.$_label
        }
      }
    )
  }

  return renderDefaultSlot.call(this, h)
}

function renderLabel(h) {
  return h(
    'div',
    {
      class: `${className}__label`
    },
    [ renderLabelContent.call(this, h) ]
  )
}

function renderPreLoader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: `${className}__loading`
      },
      [
        h(
          preloader,
          {
            props: {
              size: this.preloaderSize,
              color: this.preloaderColor,
              count: this.preloaderCount
            }
          }
        )
      ]
    )
  }
}

export default function(h) {
  if (this.hasContent) {
    return h(
      this.$_tag,
      {
        class: this.$_class,
        props: {
          to: this.to
        },
        directives: this.$_directives,
        on: this.$eventHandlers
      },
      [
        renderLabel.call(this, h),
        renderCancelable.call(this, h),
        renderPreLoader.call(this, h)
      ]
    )
  }
}
